import { Fragment, useLayoutEffect, useRef } from 'react';
import { t } from '../../../i18n';
import { dayLabel, fmtTime } from '../../../lib/format';
import type { ChatMessage } from './types';

// Verlauf eines Chats: Tagestrenner, Sprechblasen (eigene rechts), Uhrzeit, angehängte Dateien.
// Scrollt bei jeder neuen Nachricht nach unten (wie in der Demo).
export function ChatMessages({
  messages,
  isMine,
  onOpenFile,
  empty,
}: {
  messages: ChatMessage[];
  isMine(m: ChatMessage): boolean;
  onOpenFile(m: ChatMessage): void;
  empty: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const lastId = messages[messages.length - 1]?.id;
  useLayoutEffect(() => {
    const el = ref.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [lastId, messages.length]);

  const now = new Date();
  let lastDay = '';
  return (
    <div className="msgs" ref={ref} role="log" aria-label={t('Nachrichten')} tabIndex={0}>
      {messages.length === 0 && <div className="chat-empty">{empty}</div>}
      {messages.map((m) => {
        const day = dayLabel(m.at, now);
        const sep = day !== lastDay;
        lastDay = day;
        return (
          <Fragment key={m.id}>
            {sep && <span className="day">{day}</span>}
            <div className={`msg ${isMine(m) ? 'out' : 'in'}`}>
              <span dir="auto">{m.text}</span>
              {m.file && (
                <button type="button" className="att" title={t('Öffnen')} onClick={() => onOpenFile(m)}>
                  📄 {m.file.name}
                </button>
              )}
              <small>{fmtTime(m.at)}</small>
            </div>
          </Fragment>
        );
      })}
    </div>
  );
}
